import { useMutation } from "@tanstack/react-query";
import { sendBusinessAppointmentReminder } from "apis";
import queryClient from "../../instances/react-query-client";
import { getAllQueuesQuery } from "./get-all-queues";

export const useSendAppointmentReminder = () => {
  return useMutation(sendBusinessAppointmentReminder, {});
};
